import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Handlecoappuser(state = initialState, action) {
  switch (action.type) {
    case userConstants.HANDLECOAPPUSER_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.HANDLECOAPPUSER_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.HANDLECOAPPUSER_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}